angular.module('rjmNg.api').factory 'MagentoStores', [
  "$resource"
  "phpServiceUrl"
  (
    $resource,
    phpServiceUrl
  ) ->

    (clientId) ->

      magentoStores = $resource(phpServiceUrl("/client/#{clientId}/magento/stores"), {},
        getAll:
          cache: true
          method: 'GET'
      )

      magentoStores
]
